import { AuthUser } from "@/types";


export function isAuthorized(userGroups: string[], requiredGroups: string[] = []): boolean {
    if (requiredGroups.length === 0) return true;
    if (!userGroups || userGroups.length === 0) return false;

    return userGroups.some(group => requiredGroups.includes(group));
}